<ng-container [ngSwitch]="loaderType">
  <ng-container *ngSwitchCase="LoadingTypeEnum.SPINNER">
    <div class="ui basic segment" style="height: 80vh">
      <div class="ui active inverted dimmer">
        <div class="ui medium text loader">Loading</div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="LoadingTypeEnum.LINES">
    <div class="ui placeholder">
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="LoadingTypeEnum.CARDS">
    <div class="ui five doubling stackable cards">
      <div class="ui card" *ngFor="let x of [0, 1, 2, 3, 4]">
        <div class="image">
          <div class="ui placeholder">
            <div class="square image"></div>
          </div>
        </div>
        <div class="content">
          <div class="ui placeholder">
            <div class="header">
              <div class="very short line"></div>
              <div class="medium line"></div>
            </div>
            <div class="paragraph">
              <div class="short line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div *ngSwitchDefault>output2</div>
</ng-container>
